<div class="wrapper flex vcenter">
  <span class="message {{type}} grow1">{{message}}</span>
  <a class="action" (click)="dismiss()">{{action}}</a>
</div>
